// import { useState, useEffect } from 'react';
// import { poApi, suppliersApi, brandsApi, lookupApi, itemsApi } from '../api';
// import { useData, submitForm, useSubmit } from '../hooks/useData';
// import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn, PdfBtn, Badge, Icons } from '../components/common';
// import toast from 'react-hot-toast';
// import { getBDDate } from '../utils/dateUtils';
// import { downloadReport } from '../utils/downloadUtils';

// const EMPTY = {
//   po_number:'', supplier_id:'', brand_id:'',
//   po_date: getBDDate(),
//   what_to_purchase:'', total_price:'', total_qty:'',
//   arrival_date:'', status:'created',
//   weight_of_package:'', delivery_charge:'0', other_cost:'0'
// };
// const EMPTY_LINE = { item_id:'', unit_price:'', quantity:1 };

// const EMPTY_NEW_ITEM = {
//   color_variation_id: '', additional_name: '', item_name: '',
//   cost_per_item: '', selling_price: '', description: ''
// };

// // Unit Cost Calculator state (UI only, not saved to DB) — the PKR-cost x
// // exchange-rate helper. Weight / Delivery Charge / Other Cost live directly
// // on `form` now (they're real PO fields, saved to the DB — see below).
// const EMPTY_PO_CALC = {
//   qty:'', pkr_cost:'', exchange_rate:'', unit_cost:''
// };

// export default function PurchaseOrdersPage() {
//   const { data, loading, reload } = useData(poApi.list);
//   const { data: suppliers }       = useData(suppliersApi.list);
//   const { data: brands }          = useData(brandsApi.active);
//   const { data: statuses }        = useData(lookupApi.statuses);
//   const { data: colors }          = useData(lookupApi.colors);
//   const { data: allItems, reload: reloadItems } = useData(itemsApi.active);

//   const [modal, setModal]   = useState(null);
//   const [form, setForm]     = useState(EMPTY);
//   const [lines, setLines]   = useState([]);
//   const [errors, setErrors] = useState({});
//   const [search, setSearch] = useState('');
//   const [saving, setSaving] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [doSubmit, poSaving] = useSubmit();

//   // Unit Cost Calculator (PKR cost x exchange rate helper)
//   const [poCalc, setPoCalc]           = useState(EMPTY_PO_CALC);
//   // poCalcResult = Cost per Unit (item cost + delivery + other, allocated per
//   // unit) — this IS what "Apply to All Lines" writes onto each PO line, so
//   // the PO's total_price already reflects the full landed cost. GRN then
//   // uses that total as-is, without adding delivery/other again.
//   const [poCalcResult, setPoCalcResult] = useState(null);
//   // KG/Rate helper (UI only) — multiplied by form.weight_of_package to auto-fill form.delivery_charge
//   const [kgRate, setKgRate] = useState('');
//   // Step 2 — profit margin on top of Cost per Unit, producing a Selling
//   // Price reference (mirrors the Items page calculator's Step 1/Step 2 flow)
//   const [calcMargin, setCalcMargin]             = useState('');
//   const [calcSellingPrice, setCalcSellingPrice] = useState(null);

//   // Auto-generated PO Number tracking — only overwrite the field while it still
//   // matches our own last suggestion, so a manually typed PO number is never clobbered
//   const [lastAutoPo, setLastAutoPo] = useState('');

//   // ── Create Item (inline, before "Items to Purchase") ─────
//   const [newItem, setNewItem]           = useState(EMPTY_NEW_ITEM);
//   const [newItemErrors, setNewItemErrors] = useState({});
//   const [creatingItem, setCreatingItem]   = useState(false);
//   // Track our own last auto-suggestions so we never clobber a manual edit
//   const [lastAutoItemName, setLastAutoItemName]       = useState('');
//   const [lastAutoCost, setLastAutoCost]               = useState('');
//   const [lastAutoSellingPrice, setLastAutoSellingPrice] = useState('');

//   // ── Filtered lists based on selection ───────────────────
//   // Brands filtered by selected supplier
//   const brandsForSupplier = form.supplier_id
//     ? brands.filter(b => String(b.supplier_id) === String(form.supplier_id))
//     : brands;

//   // Supplier for selected brand (single)
//   const supplierForBrand = form.brand_id
//     ? brands.find(b => String(b.id) === String(form.brand_id))
//     : null;

//   // Items filtered by selected brand
//   const filteredItems = allItems.filter(i => String(i.brand_id) === String(form.brand_id));

//   const set = e => {
//     const { name, value } = e.target;
//     if (name === 'supplier_id') {
//       // When supplier changes, clear brand and lines if brand doesn't belong to this supplier
//       const currentBrandOk = brandsForSupplier.some(b => String(b.id) === String(form.brand_id));
//       setForm(f => ({
//         ...f,
//         supplier_id: value,
//         brand_id: currentBrandOk ? f.brand_id : '',
//       }));
//       if (!currentBrandOk) setLines([]);
//     } else if (name === 'brand_id') {
//       // When brand changes, auto-fill supplier and clear lines
//       const brand = brands.find(b => String(b.id) === String(value));
//       setForm(f => ({
//         ...f,
//         brand_id:    value,
//         supplier_id: brand?.supplier_id || f.supplier_id,
//       }));
//       setLines([]);
//     } else {
//       setForm(f => ({ ...f, [name]: value }));
//     }
//     setErrors(er => ({ ...er, [name]: '' }));
//   };

//   // Auto-calculate totals from lines
//   useEffect(() => {
//     if (lines.length === 0) return;
//     const total_qty   = lines.reduce((s,l) => s + (parseInt(l.quantity)||0), 0);
//     const total_price = lines.reduce((s,l) => s + (parseFloat(l.unit_price)||0)*(parseInt(l.quantity)||0), 0);
//     setForm(f => ({ ...f, total_qty, total_price: total_price.toFixed(2) }));
//   }, [lines]);

//   const handleItemChange = (idx, itemId) => {
//     setLines(ls => ls.map((l,i) => i===idx
//       ? { ...l, item_id: itemId, unit_price: '' }
//       : l
//     ));
//   };
//   const setLine = (idx, field, val) =>
//     setLines(ls => ls.map((l,i) => i===idx ? { ...l, [field]: val } : l));
//   const addLine = () => setLines(ls => [...ls, { ...EMPTY_LINE }]);
//   const delLine = idx => setLines(ls => ls.filter((_,i) => i!==idx));

//   // ── Unit Cost Calculator handlers ───────────────────────
//   const setPoC = e => setPoCalc(v => ({ ...v, [e.target.name]: e.target.value }));

//   // Total Unit Cost (BDT) = Total Cost (PKR) × Exchange Rate — auto-filled
//   useEffect(() => {
//     const pkr  = parseFloat(poCalc.pkr_cost)      || 0;
//     const rate = parseFloat(poCalc.exchange_rate) || 0;
//     const val  = pkr / rate;
//     setPoCalc(c => ({ ...c, unit_cost: val ? val.toFixed(2) : '' }));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [poCalc.pkr_cost, poCalc.exchange_rate]);

//   // Delivery Charge (৳) = KG/Rate × Package Weight — auto-filled onto the real form field
//   // (these are genuine PO fields now, saved to the DB, not calculator-only helpers)
//   useEffect(() => {
//     const kg = parseFloat(kgRate) || 0;
//     const w  = parseFloat(form.weight_of_package) || 0;
//     const val = kg * w;
//     setForm(f => ({ ...f, delivery_charge: val ? val.toFixed(2) : '0' }));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [kgRate, form.weight_of_package]);

//   const handlePoCalc = () => {
//     const qty  = parseFloat(poCalc.qty)           || 0;
//     const unit = parseFloat(poCalc.unit_cost)     || 0;
//     const del  = parseFloat(form.delivery_charge) || 0;
//     const oth  = parseFloat(form.other_cost)      || 0;
//     if (qty <= 0) { alert('Please enter a valid quantity'); return; }
//     setPoCalcResult((unit + del + oth) / qty);
//     setCalcMargin(''); setCalcSellingPrice(null);
//   };

//   const handleApplyToAllLines = () => {
//     if (poCalcResult === null || lines.length === 0) return;
//     const priceStr = poCalcResult.toFixed(2);
//     setLines(ls => ls.map(l => ({ ...l, unit_price: priceStr })));
//   };

//   // Step 2 — profit margin on top of Cost per Unit → Selling Price reference
//   const applyCalcMargin = () => {
//     if (poCalcResult === null) return;
//     const margin = parseFloat(calcMargin) || 0;
//     setCalcSellingPrice(poCalcResult * (1 + margin / 100));
//   };

//   const resetPoCalc = () => {
//     setPoCalc(EMPTY_PO_CALC); setPoCalcResult(null); setKgRate('');
//     setCalcMargin(''); setCalcSellingPrice(null);
//   };

//   // Auto-generate PO Number once both supplier and brand are chosen (new PO only).
//   // Only overwrites the field if it's empty or still equal to our own last suggestion,
//   // so it never clobbers something the user typed in manually.
//   useEffect(() => {
//     if (modal !== 'add') return;
//     if (!form.supplier_id || !form.brand_id) return;
//     if (form.po_number && form.po_number !== lastAutoPo) return;

//     let cancelled = false;
//     (async () => {
//       try {
//         const res  = await poApi.nextNumber(form.supplier_id, form.brand_id);
//         const next = res?.data?.data?.po_number;
//         if (next && !cancelled) {
//           setForm(f => ({ ...f, po_number: next }));
//           setLastAutoPo(next);
//         }
//       } catch { /* non-blocking — user can type the PO number manually */ }
//     })();
//     return () => { cancelled = true; };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.supplier_id, form.brand_id, modal]);

//   // ── Create Item (inline) ─────────────────────────────────
//   const setNewItemField = e => setNewItem(v => ({ ...v, [e.target.name]: e.target.value }));

//   // Auto-build "Item Name" from Brand + Color + Additional Name — only while
//   // the field still matches our own last suggestion, so a manual edit sticks
//   useEffect(() => {
//     const brandName = brands.find(b => String(b.id) === String(form.brand_id))?.brand_name || '';
//     const colorName  = colors.find(c => String(c.id) === String(newItem.color_variation_id))?.color_variation || '';
//     if (!brandName || !colorName) return;
//     const auto = [brandName, colorName, newItem.additional_name.trim()].filter(Boolean).join('_');
//     setNewItem(v => {
//       if (v.item_name && v.item_name !== lastAutoItemName) return v; // user typed something custom — leave it
//       return { ...v, item_name: auto };
//     });
//     setLastAutoItemName(auto);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.brand_id, newItem.color_variation_id, newItem.additional_name, brands, colors]);

//   // Pre-fill "Cost per Item" from the Unit Cost Calculator's Cost per Unit —
//   // only while it still matches our own last suggestion, so a manual edit sticks
//   useEffect(() => {
//     if (poCalcResult === null) return;
//     const auto = poCalcResult.toFixed(2);
//     setNewItem(v => {
//       if (v.cost_per_item && v.cost_per_item !== lastAutoCost) return v;
//       return { ...v, cost_per_item: auto };
//     });
//     setLastAutoCost(auto);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [poCalcResult]);

//   // Pre-fill "Selling Price" from the calculator's Step 2 margin result —
//   // only while it still matches our own last suggestion, so a manual edit sticks
//   useEffect(() => {
//     if (calcSellingPrice === null) return;
//     const auto = calcSellingPrice.toFixed(2);
//     setNewItem(v => {
//       if (v.selling_price && v.selling_price !== lastAutoSellingPrice) return v;
//       return { ...v, selling_price: auto };
//     });
//     setLastAutoSellingPrice(auto);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [calcSellingPrice]);

//   const resetNewItem = () => {
//     setNewItem(EMPTY_NEW_ITEM); setNewItemErrors({});
//     setLastAutoItemName(''); setLastAutoCost(''); setLastAutoSellingPrice('');
//   };

//   const handleCreateItem = async () => {
//     const e = {};
//     if (!form.brand_id) e.brand = 'Select a brand above first';
//     if (!newItem.color_variation_id) e.color = 'Select a color / variation';
//     if (!newItem.item_name.trim()) e.item_name = 'Item name is required';
//     else {
//       const nameLower = newItem.item_name.trim().toLowerCase();
//       const dup = allItems.some(i => i.item_name?.trim().toLowerCase() === nameLower);
//       if (dup) e.item_name = 'An item with this name already exists';
//     }
//     if (!newItem.selling_price || isNaN(newItem.selling_price) || Number(newItem.selling_price) < 0) e.selling_price = 'Valid selling price is required';
//     setNewItemErrors(e);
//     if (Object.keys(e).length) { toast.error('Please fill in all required fields'); return; }

//     setCreatingItem(true);
//     try {
//       const fd = new FormData();
//       fd.append('brand_id', form.brand_id);
//       fd.append('color_variation_id', newItem.color_variation_id);
//       fd.append('item_name', newItem.item_name.trim());
//       fd.append('description', newItem.description || '');
//       fd.append('price', newItem.selling_price);
//       fd.append('date_created', getBDDate());

//       const res = await itemsApi.create(fd);
//       const newId = res?.data?.id;
//       toast.success('Item created');
//       await reloadItems(); // so it shows up in the "Items to Purchase" dropdown

//       // Add it straight onto the PO as a line, seeded with the Cost per Item
//       // value shown above — same Cost per Unit that "Apply to All Lines" uses,
//       // so every line on this PO is priced consistently.
//       if (newId) {
//         setLines(ls => [...ls, { item_id: String(newId), unit_price: newItem.cost_per_item || '', quantity: 1 }]);
//       }
//       resetNewItem();
//     } catch (err) {
//       toast.error(err?.response?.data?.message || 'Failed to create item');
//     } finally {
//       setCreatingItem(false);
//     }
//   };

//   const openAdd = () => {
//     setForm(EMPTY); setLines([]); setErrors({}); resetPoCalc(); resetNewItem(); setLastAutoPo(''); setModal('add');
//   };

//   const openEdit = async (row) => {
//     setSaving(true);
//     try {
//       const res = await poApi.getOne(row.id);
//       const po  = res.data.data;
//       setForm({
//         ...po,
//         weight_of_package: po.weight_of_package ?? '',
//         delivery_charge:   po.delivery_charge   ?? '0',
//         other_cost:        po.other_cost        ?? '0',
//       });
//       setLines(po.details?.length > 0 ? po.details.map(d => ({
//         item_id:    d.item_id,
//         unit_price: d.unit_price,
//         quantity:   d.quantity,
//       })) : []);
//       setErrors({});
//       resetNewItem();

//       // Restore the full Unit Cost Calculator from what was saved on this PO,
//       // so editing shows everything back instead of blank fields
//       const qty      = po.calc_qty          ?? '';
//       const pkrCost  = po.calc_pkr_cost     ?? '';
//       const exRate   = po.calc_exchange_rate ?? '';
//       const unitCostBdt = (parseFloat(pkrCost) || 0) / (parseFloat(exRate) || 0);
//       setPoCalc({
//         qty: qty === '' ? '' : String(qty),
//         pkr_cost: pkrCost === '' ? '' : String(pkrCost),
//         exchange_rate: exRate === '' ? '' : String(exRate),
//         unit_cost: unitCostBdt ? unitCostBdt.toFixed(2) : '',
//       });
//       setCalcMargin(''); setCalcSellingPrice(null);

//       // Back-derive the KG/Rate helper from the saved weight+delivery charge, so
//       // editing an existing PO shows a sensible starting rate instead of blank
//       const w = parseFloat(po.weight_of_package) || 0;
//       const d = parseFloat(po.delivery_charge) || 0;
//       setKgRate(w > 0 ? (d / w).toFixed(2) : '');

//       // Immediately show the Cost per Unit result too (no need to click Calculate again)
//       const qtyNum = parseFloat(qty) || 0;
//       const del    = parseFloat(po.delivery_charge) || 0;
//       const oth    = parseFloat(po.other_cost) || 0;
//       setPoCalcResult(qtyNum > 0 ? (unitCostBdt + del + oth) / qtyNum : null);

//       setLastAutoPo('');
//       setModal('edit');

//     } catch { toast.error('Failed to load PO'); }
//     finally { setSaving(false); }
//   };

//   const validate = () => {
//     const e = {};
//     if (!form.po_number?.trim()) e.po_number  = 'PO number is required';
//     if (!form.supplier_id)       e.supplier_id = 'Select a supplier';
//     if (!form.brand_id)          e.brand_id    = 'Select a brand';
//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const handleSave = () => {
//     if (!validate()) { toast.error('Please fill in all required fields'); return; }
//     const payload = {
//       ...form,
//       details: lines.filter(l => l.item_id),
//       calc_qty: poCalc.qty || null,
//       calc_pkr_cost: poCalc.pkr_cost || null,
//       calc_exchange_rate: poCalc.exchange_rate || null,
//     };
//     if (modal==='add') doSubmit(() => poApi.create(payload), 'PO created', reload, () => setModal(null));
//     else               doSubmit(() => poApi.update(form.id, payload), 'PO updated', reload, () => setModal(null));
//   };

//   const handleExport = async () => {
//     setExporting(true);
//     try {
//       await downloadReport(poApi.exportExcel, 'purchase-orders-list.xlsx');
//     } catch {
//       toast.error('Export failed — please try again');
//     } finally {
//       setExporting(false);
//     }
//   };

//   const filtered = data.filter(r =>
//     !search ||
//     r.po_number?.toLowerCase().includes(search.toLowerCase()) ||
//     r.supplier_name?.toLowerCase().includes(search.toLowerCase()) ||
//     r.brand_name?.toLowerCase().includes(search.toLowerCase())
//   );

//   const lineTotal = lines.reduce((s,l) => s + (parseFloat(l.unit_price)||0)*(parseInt(l.quantity)||0), 0);
//   const lineQty   = lines.reduce((s,l) => s + (parseInt(l.quantity)||0), 0);

//   return (
//     <div>
//       <PageHeader title="Purchase Orders" subtitle="Create and manage purchase orders"
//         action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ New PO</button>} />

//       <div className="card">
//         <div className="card-header">
//           <div className="search-wrap">
//             <Icons.Search size={14} className="search-icon" />
//             <input type="text" className="search-input" placeholder="Search by PO#, supplier or brand…"
//               value={search} onChange={e => setSearch(e.target.value)} />
//           </div>
//           <button className="btn btn-secondary btn-sm" onClick={handleExport} disabled={exporting}>
//             {exporting ? 'Exporting…' : 'Export Excel'}
//           </button>
//         </div>
//         {loading ? <Spinner /> : (
//           <div className="table-wrap">
//             {filtered.length===0 ? <Empty msg="No purchase orders yet" /> : (
//               <table className="responsive-table">
//                 <thead><tr>
//                   <th>PO #</th><th>Supplier / Brand</th>
//                   <th>Qty</th><th>Total</th><th>Arrival</th><th>Status</th><th>Actions</th>
//                 </tr></thead>
//                 <tbody>{filtered.map(r => (
//                   <tr key={r.id}>
//                     <td data-label="PO #">
//                       <div className="td-primary font-mono">{r.po_number}</div>
//                       <div className="td-muted">{r.po_date}</div>
//                     </td>
//                     <td data-label="Supplier / Brand">
//                       <div className="td-primary">{r.supplier_name}</div>
//                       <div className="td-muted">{r.brand_name}</div>
//                     </td>
//                     <td data-label="Qty" className="font-mono">{r.total_qty}</td>
//                     <td data-label="Total" className="font-mono">৳{Number(r.total_price).toLocaleString()}</td>
//                     <td data-label="Arrival" className="text-muted">{r.arrival_date||'—'}</td>
//                     <td data-label="Status"><Badge status={r.status} /></td>
//                     <td data-label="Actions"><div className="action-cell">
//                       <EditBtn onClick={() => {
//                         if (r.status === 'all_done') {
//                           toast.error("This PO's goods have already been received (GRN completed) — it can no longer be edited");
//                           return;
//                         }
//                         openEdit(r);
//                       }} />
//                       <CancelBtn onClick={() => submitForm(() => poApi.cancel(r.id),'PO set to pending',reload)} label="Set Pending" />
//                       <PdfBtn href={poApi.pdf(r.id)} />
//                     </div></td>
//                   </tr>
//                 ))}</tbody>
//               </table>
//             )}
//           </div>
//         )}
//       </div>

//       {saving && (
//         <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 }}>
//           <div style={{ background:'white', padding:'24px 32px', borderRadius:12, fontSize:'1rem' }}>Loading PO details…</div>
//         </div>
//       )}

//       {modal && (
//         <Modal title={modal==='add' ? 'New Purchase Order' : 'Edit Purchase Order'}
//           onClose={() => setModal(null)} size="modal-lg"
//           footer={<>
//             <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
//             <button className="btn btn-primary" onClick={handleSave} disabled={poSaving}>{poSaving ? 'Saving…' : 'Save PO'}</button>
//           </>}>

//           <div className="form-row form-row-2">
//             <Field label="PO Number" required>
//               <input type="text" name="po_number" value={form.po_number} onChange={set}
//                 placeholder="e.g. PO-2024-001" autoFocus
//                 style={errors.po_number?{borderColor:'var(--c-danger)'}:{}} />
//               {errors.po_number && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.po_number}</span>}
//               {modal==='add' && (
//                 <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
//                   Auto-generated once supplier + brand are selected — you can edit it if needed
//                 </span>
//               )}
//             </Field>
//             <Field label="PO Date">
//               <input type="date" name="po_date" value={form.po_date} onChange={set} />
//             </Field>
//           </div>

//           {/* Supplier ↔ Brand cross-filtering */}
//           <div className="form-row form-row-2">
//             <Field label="Supplier" required>
//               <select name="supplier_id" value={form.supplier_id} onChange={set}
//                 style={errors.supplier_id?{borderColor:'var(--c-danger)'}:{}}>
//                 <option value="">Select supplier…</option>
//                 {suppliers.filter(s=>s.active_yes_no).map(s =>
//                   <option key={s.id} value={s.id}>{s.full_name}</option>)}
//               </select>
//               {errors.supplier_id && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.supplier_id}</span>}
//               {form.supplier_id && (
//                 <span style={{fontSize:'.74rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
//                   Showing {brandsForSupplier.length} brand{brandsForSupplier.length!==1?'s':''} for this supplier
//                 </span>
//               )}
//             </Field>
//             <Field label="Brand" required>
//               <select name="brand_id" value={form.brand_id} onChange={set}
//                 style={errors.brand_id?{borderColor:'var(--c-danger)'}:{}}>
//                 <option value="">Select brand…</option>
//                 {brandsForSupplier.map(b => <option key={b.id} value={b.id}>{b.brand_name}</option>)}
//               </select>
//               {errors.brand_id && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.brand_id}</span>}
//               {form.brand_id && supplierForBrand && !form.supplier_id && (
//                 <span style={{fontSize:'.74rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
//                   Supplier: {suppliers.find(s=>String(s.id)===String(supplierForBrand.supplier_id))?.full_name}
//                 </span>
//               )}
//             </Field>
//           </div>

//           {form.brand_id && (
//             <>
//                   {/* ── Unit Cost Calculator ── */}
//                   <div style={{ margin:'0 0 16px', padding:'16px 18px', background:'var(--c-accent-tint)', border:'1px solid var(--c-border)', borderLeft:'3px solid var(--c-accent)', borderRadius:'var(--r-md)' }}>
//                     <div style={{ fontWeight:600, fontSize:'.88rem', color:'var(--c-text)', marginBottom:12 }}>
//                       Unit Cost Calculator <span style={{ fontWeight:400, color:'var(--c-text-3)', fontSize:'.78rem' }}>— optional, fills Unit Cost for all lines</span>
//                     </div>

//                     <div style={{ fontSize:'.75rem', fontWeight:600, letterSpacing:'.08em', textTransform:'uppercase', color:'var(--c-text-3)', marginBottom:8 }}>
//                       Step 1 — Enter Costs
//                     </div>

//                     <div className="form-row form-row-3" style={{ marginBottom:10 }}>
//                       <Field label="Quantity (pcs)">
//                         <input type="number" name="qty" value={poCalc.qty} onChange={setPoC} min="1" placeholder="e.g. 10" />
//                       </Field>
//                       <Field label="Total Cost (PKR)">
//                         <input type="number" name="pkr_cost" value={poCalc.pkr_cost} onChange={setPoC} min="0" step="0.01" placeholder="e.g. 500" />
//                       </Field>
//                       <Field label="Exchange Rate">
//                         <input type="number" name="exchange_rate" value={poCalc.exchange_rate} onChange={setPoC} min="0" step="0.01" placeholder="e.g. 3.5" />
//                       </Field>
//                     </div>

//                     <div className="form-row form-row-2" style={{ marginBottom:10 }}>
//                       <Field label="Total Unit Cost (BDT)">
//                         <input type="number" value={poCalc.unit_cost} readOnly placeholder="Auto-calculated"
//                           style={{ backgroundColor:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' }} />
//                       </Field>
//                       <Field label="KG / Rate (৳)">
//                         <input type="number" value={kgRate} onChange={e => setKgRate(e.target.value)}
//                           min="0" step="0.01" placeholder="e.g. 250" />
//                       </Field>
//                     </div>

//                     <div className="form-row form-row-3" style={{ marginBottom:10 }}>
//                       <Field label="Package Weight (kg)">
//                         <input type="number" name="weight_of_package" value={form.weight_of_package || ''}
//                           onChange={set} min="0" step="0.01" placeholder="0.00" />
//                       </Field>
//                       <Field label="Shipping Charge (৳)">
//                         <input type="number" value={form.delivery_charge} readOnly placeholder="Auto-calculated"
//                           style={{ backgroundColor:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' }} />
//                       </Field>
//                       <Field label="Delivery Cost (৳)">
//                         <input type="number" name="other_cost" value={form.other_cost} onChange={set}
//                           min="0" step="0.01" placeholder="0.00" />
//                       </Field>
//                     </div>

//                     <div style={{ display:'flex', justifyContent:'flex-end', marginBottom: poCalcResult !== null ? 12 : 0 }}>
//                       <button type="button" className="btn btn-secondary" onClick={handlePoCalc}>
//                         Calculate
//                       </button>
//                     </div>

//                     {poCalcResult !== null && (
//                       <>
//                         <div style={{ padding:'10px 14px', background:'var(--c-surface)', border:'1px solid var(--c-border)', borderRadius:'var(--r-sm)', fontSize:'.88rem', marginBottom:12 }}>
//                           <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, flexWrap:'wrap' }}>
//                             <div>
//                               <span style={{ color:'var(--c-text-3)' }}>Cost per Unit: </span>
//                               <strong className="font-mono" style={{ color:'var(--c-text)', fontSize:'1rem' }}>৳{poCalcResult.toFixed(2)}</strong>
//                               <span style={{ color:'var(--c-text-3)', marginLeft:12, fontSize:'.78rem' }}>
//                                 = ({poCalc.unit_cost || 0} + {form.delivery_charge || 0} + {form.other_cost || 0}) ÷ {poCalc.qty}
//                               </span>
//                             </div>
//                             <button type="button" className="btn btn-primary btn-sm" onClick={handleApplyToAllLines} disabled={lines.length===0}>
//                               Apply → All Lines
//                             </button>
//                           </div>
//                         </div>

//                         <div style={{ fontSize:'.75rem', fontWeight:600, letterSpacing:'.08em', textTransform:'uppercase', color:'var(--c-text-3)', marginBottom:8 }}>
//                           Step 2 — Add Profit Margin
//                         </div>
//                         <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'flex-end' }}>
//                           {[10,20,30,40,50].map(pct => (
//                             <button key={pct} type="button"
//                               className={`btn btn-sm ${String(calcMargin)===String(pct) ? 'btn-primary' : 'btn-secondary'}`}
//                               onClick={() => setCalcMargin(pct)}>
//                               +{pct}%
//                             </button>
//                           ))}
//                           <div style={{ display:'flex', gap:6, alignItems:'center', flex:'0 0 auto' }}>
//                             <input type="number" value={calcMargin} onChange={e => setCalcMargin(e.target.value)}
//                               placeholder="Custom %" min="0" step="0.01" style={{ width:100 }} />
//                             <span style={{ fontSize:'.82rem', color:'var(--c-text-3)' }}>%</span>
//                           </div>
//                           <button type="button" className="btn btn-primary btn-sm" onClick={applyCalcMargin} disabled={!calcMargin}>
//                             Apply → Selling Price
//                           </button>
//                         </div>

//                         {calcSellingPrice !== null && (
//                           <div style={{ marginTop:10, fontSize:'.84rem', color:'var(--c-text-2)' }}>
//                             ৳{poCalcResult.toFixed(2)} × {(1 + parseFloat(calcMargin||0)/100).toFixed(2)} =
//                             <strong style={{ color:'var(--c-accent)', marginLeft:4 }}>
//                               Selling Price ৳{calcSellingPrice.toFixed(2)}
//                             </strong>
//                             <span style={{ color:'var(--c-text-3)', marginLeft:8, fontSize:'.76rem' }}>
//                               — pre-fills "Selling Price" below when creating a new item
//                             </span>
//                           </div>
//                         )}
//                       </>
//                     )}
//                   </div>
//             </>
//           )}

//           {/* ── Create Item (inline) ── */}
//           {form.brand_id && (
//             <div style={{ margin:'0 0 16px', padding:'16px 18px', background:'var(--c-accent-tint)', border:'1px solid var(--c-border)', borderLeft:'3px solid var(--c-accent)', borderRadius:'var(--r-md)' }}>
//               <div style={{ fontWeight:600, fontSize:'.88rem', color:'var(--c-text)', marginBottom:12 }}>
//                 Create New Item <span style={{ fontWeight:400, color:'var(--c-text-3)', fontSize:'.78rem' }}>— optional, adds it to this brand and to the PO below</span>
//               </div>

//               <div className="form-row form-row-2" style={{ marginBottom:10 }}>
//                 <Field label="Color / Variation" required>
//                   <select name="color_variation_id" value={newItem.color_variation_id} onChange={setNewItemField}
//                     style={newItemErrors.color ? {borderColor:'var(--c-danger)'} : {}}>
//                     <option value="">Select color…</option>
//                     {colors.filter(c=>c.active_yes_no).map(c => <option key={c.id} value={c.id}>{c.color_variation}</option>)}
//                   </select>
//                   {newItemErrors.color && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.color}</span>}
//                 </Field>
//                 <Field label="Additional Name (optional)">
//                   <input type="text" name="additional_name" value={newItem.additional_name} onChange={setNewItemField}
//                     placeholder="e.g. Slim Fit" />
//                 </Field>
//               </div>

//               <Field label="Item Name" required>
//                 <input type="text" name="item_name" value={newItem.item_name} onChange={setNewItemField}
//                   placeholder="Auto-built from Brand + Color + Additional Name — you can edit it"
//                   style={newItemErrors.item_name ? {borderColor:'var(--c-danger)'} : {}} />
//                 {newItemErrors.item_name && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.item_name}</span>}
//               </Field>

//               <div className="form-row form-row-2" style={{ margin:'10px 0' }}>
//                 <Field label="Cost per Item (৳)">
//                   <input type="number" name="cost_per_item" value={newItem.cost_per_item} onChange={setNewItemField}
//                     min="0" step="0.01" placeholder="From calculator above, or type manually" />
//                   <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
//                     Same Cost per Unit as the PO line above (item + delivery + other)
//                   </span>
//                 </Field>
//                 <Field label="Selling Price (৳)" required>
//                   <input type="number" name="selling_price" value={newItem.selling_price} onChange={setNewItemField}
//                     min="0" step="0.01" placeholder="Use Step 2 above, or type manually"
//                     style={newItemErrors.selling_price ? {borderColor:'var(--c-danger)'} : {}} />
//                   {newItemErrors.selling_price && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.selling_price}</span>}
//                 </Field>
//               </div>

//               <Field label="Description">
//                 <textarea name="description" value={newItem.description} onChange={setNewItemField} rows={2}
//                   placeholder="Optional product description…" />
//               </Field>

//               <div style={{ display:'flex', justifyContent:'flex-end', marginTop:10 }}>
//                 <button type="button" className="btn btn-primary btn-sm" onClick={handleCreateItem} disabled={creatingItem}>
//                   {creatingItem ? 'Saving…' : 'Save Item'}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ── Item lines ── */}
//           {form.brand_id ? (
//             <>
//               <div className="section-label" style={{marginTop:8}}>Items to Purchase</div>
//               {filteredItems.length === 0 ? (
//                 <div style={{padding:'12px 14px',background:'var(--c-warning-lt)',border:'1px solid rgba(176,125,26,.2)',borderRadius:'var(--r-sm)',fontSize:'.84rem',color:'var(--c-warning)',marginBottom:12}}>
//                   No active items found for this brand yet. Use "Create New Item" above to add one.
//                 </div>
//               ) : (
//                 <>
//                   <div style={{overflowX:'auto',marginBottom:8}}>
//                     <table className="detail-table">
//                       <thead><tr>
//                         <th style={{minWidth:220}}>Item</th>
//                         <th style={{minWidth:140}}>
//                           Unit Cost (৳)
//                           <span title="Unit cost = full landed cost per piece, including delivery and other charges (allocated evenly across quantity). Decided here, on the PO — GRN uses this total as-is."
//                             style={{marginLeft:5,cursor:'help',color:'var(--c-text-3)',fontSize:'.75rem',
//                               background:'var(--c-bg)',border:'1px solid var(--c-border)',
//                               borderRadius:'50%',width:16,height:16,display:'inline-flex',
//                               alignItems:'center',justifyContent:'center'}}>
//                             ?
//                           </span>
//                         </th>
//                         <th style={{minWidth:80}}>Qty</th>
//                         <th style={{minWidth:110}}>Total Cost (৳)</th>
//                         <th style={{width:36}}></th>
//                       </tr></thead>
//                       <tbody>
//                         {lines.map((line,idx) => (
//                           <tr key={idx}>
//                             <td>
//                               <select value={line.item_id} onChange={e => handleItemChange(idx, e.target.value)}>
//                                 <option value="">Select item…</option>
//                                 {filteredItems.map(i =>
//                                   <option key={i.id} value={i.id}>{i.item_name}</option>)}
//                               </select>
//                             </td>
//                             <td>
//                               <input type="number" value={line.unit_price} min="0" step="0.01"
//                                 placeholder="0.00"
//                                 onChange={e => setLine(idx,'unit_price',e.target.value)} />
//                             </td>
//                             <td>
//                               <input type="number" value={line.quantity} min="1"
//                                 onChange={e => setLine(idx,'quantity',e.target.value)} />
//                             </td>
//                             <td className="fw-500 font-mono">
//                               ৳{((parseFloat(line.unit_price)||0)*(parseInt(line.quantity)||0)).toLocaleString()}
//                             </td>
//                             <td>
//                               <button className="del-btn" onClick={() => delLine(idx)} title="Remove">
//                                 <Icons.Cancel size={13}/>
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                         {lines.length===0 && (
//                           <tr>
//                             <td colSpan={5} style={{textAlign:'center',color:'var(--c-text-3)',padding:'16px',fontSize:'.84rem'}}>
//                               No items added yet — click "+ Add Item" below.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                   <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
//                     <button className="btn btn-ghost btn-sm" onClick={addLine}>
//                       <Icons.Plus size={13}/> Add Item
//                     </button>
//                     {lines.length > 0 && (
//                       <span style={{fontSize:'.88rem',color:'var(--c-text-2)'}}>
//                         Total Cost: <strong className="font-mono">৳{lineTotal.toLocaleString()}</strong>
//                         &nbsp;|&nbsp; Qty: <strong>{lineQty}</strong>
//                       </span>
//                     )}
//                   </div>
//                 </>
//               )}
//             </>
//           ) : (
//             <div style={{padding:'10px 14px',background:'var(--c-bg)',borderRadius:'var(--r-sm)',fontSize:'.84rem',color:'var(--c-text-3)',marginBottom:12,border:'1px dashed var(--c-border)'}}>
//               Select a supplier and brand above to add items to this purchase order.
//             </div>
//           )}

//           {/* Summary totals */}
//           <div className="form-row form-row-3">
//             <Field label="Total Qty">
//               <input type="number" name="total_qty" value={form.total_qty} onChange={set} min="0" placeholder="0"
//                 readOnly={lines.length > 0}
//                 style={lines.length > 0 ? { background:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' } : {}} />
//             </Field>
//             <Field label="Total Cost (৳)">
//               <input type="number" name="total_price" value={form.total_price} onChange={set} min="0" step="0.01" placeholder="0.00"
//                 readOnly={lines.length > 0}
//                 style={lines.length > 0 ? { background:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' } : {}} />
//               {lines.length > 0 && (
//                 <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
//                   Auto-calculated from item lines above — already includes Delivery &amp; Other Cost.
//                 </span>
//               )}
//             </Field>
//             <Field label="Arrival Date">
//               <input type="date" name="arrival_date" value={form.arrival_date||''} onChange={set} />
//             </Field>
//           </div>

//           <Field label="Purchase Note">
//             <textarea name="what_to_purchase" value={form.what_to_purchase||''} onChange={set} rows={2}
//               placeholder="Additional notes…" />
//           </Field>
//           <Field label="Status">
//             <select name="status" value={form.status} onChange={set}>
//               {statuses.map(s => <option key={s.id} value={s.status}>{s.status}</option>)}
//             </select>
//           </Field>
//         </Modal>
//       )}
//     </div>
//   );
// }

import { useState, useEffect } from 'react';
import { poApi, suppliersApi, brandsApi, lookupApi, itemsApi } from '../api';
import { useData, submitForm, useSubmit } from '../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn, PdfBtn, Badge, Icons } from '../components/common';
import toast from 'react-hot-toast';
import { getBDDate } from '../utils/dateUtils';
import { downloadReport } from '../utils/downloadUtils';

const EMPTY = {
  po_number:'', supplier_id:'', brand_id:'',
  po_date: getBDDate(),
  what_to_purchase:'', total_price:'', total_qty:'',
  arrival_date:'', status:'created',
  weight_of_package:'', delivery_charge:'0', other_cost:'0'
};
const EMPTY_LINE = { item_id:'', unit_price:'', quantity:1 };

const EMPTY_NEW_ITEM = {
  color_variation_id: '', additional_name: '', item_name: '',
  cost_per_item: '', selling_price: '', description: ''
};

// Unit Cost Calculator state (UI only, not saved to DB) — the PKR-cost x
// exchange-rate helper. Weight / Delivery Charge / Other Cost live directly
// on `form` now (they're real PO fields, saved to the DB — see below).
const EMPTY_PO_CALC = {
  qty:'', single_unit_cost_pkr:'', pkr_cost:'', exchange_rate:'', unit_cost:''
};

export default function PurchaseOrdersPage() {
  // Stop the browser's default "scroll to change value" behavior on number
  // inputs — only manually typed values should count.
  useEffect(() => {
    const blurNumberOnWheel = () => {
      if (document.activeElement && document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', blurNumberOnWheel, { passive: true });
    return () => document.removeEventListener('wheel', blurNumberOnWheel);
  }, []);

  const { data, loading, reload } = useData(poApi.list);
  const { data: suppliers }       = useData(suppliersApi.list);
  const { data: brands }          = useData(brandsApi.active);
  const { data: statuses }        = useData(lookupApi.statuses);
  const { data: colors }          = useData(lookupApi.colors);
  const { data: allItems, reload: reloadItems } = useData(itemsApi.active);

  const [modal, setModal]   = useState(null);
  const [form, setForm]     = useState(EMPTY);
  const [lines, setLines]   = useState([]);
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState('');
  const [saving, setSaving] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [doSubmit, poSaving] = useSubmit();

  // Unit Cost Calculator (PKR cost x exchange rate helper)
  const [poCalc, setPoCalc]           = useState(EMPTY_PO_CALC);
  // poCalcResult = Cost per Unit (item cost + delivery + other, allocated per
  // unit) — this IS what "Apply to All Lines" writes onto each PO line, so
  // the PO's total_price already reflects the full landed cost. GRN then
  // uses that total as-is, without adding delivery/other again.
  const [poCalcResult, setPoCalcResult] = useState(null);
  // KG/Rate helper (UI only) — multiplied by form.weight_of_package to auto-fill form.delivery_charge
  const [kgRate, setKgRate] = useState('');
  // Track our own last auto-suggestions for Total Cost (PKR) / Total Cost (BDT)
  // so a manual edit to either sticks instead of being overwritten
  const [lastAutoPkrCost, setLastAutoPkrCost] = useState('');
  const [lastAutoUnitCost, setLastAutoUnitCost] = useState('');
  // Step 2 — profit margin on top of Cost per Unit, producing a Selling
  // Price reference (mirrors the Items page calculator's Step 1/Step 2 flow)
  const [calcMargin, setCalcMargin]             = useState('');
  const [calcSellingPrice, setCalcSellingPrice] = useState(null);

  // Auto-generated PO Number tracking — only overwrite the field while it still
  // matches our own last suggestion, so a manually typed PO number is never clobbered
  const [lastAutoPo, setLastAutoPo] = useState('');

  // ── Create Item (inline, before "Items to Purchase") ─────
  const [newItem, setNewItem]           = useState(EMPTY_NEW_ITEM);
  const [newItemErrors, setNewItemErrors] = useState({});
  const [creatingItem, setCreatingItem]   = useState(false);
  // Track our own last auto-suggestions so we never clobber a manual edit
  const [lastAutoItemName, setLastAutoItemName]       = useState('');
  const [lastAutoCost, setLastAutoCost]               = useState('');
  const [lastAutoSellingPrice, setLastAutoSellingPrice] = useState('');

  // ── Filtered lists based on selection ───────────────────
  // Brands filtered by selected supplier
  const brandsForSupplier = form.supplier_id
    ? brands.filter(b => String(b.supplier_id) === String(form.supplier_id))
    : brands;

  // Supplier for selected brand (single)
  const supplierForBrand = form.brand_id
    ? brands.find(b => String(b.id) === String(form.brand_id))
    : null;

  // Items filtered by selected brand
  const filteredItems = allItems.filter(i => String(i.brand_id) === String(form.brand_id));

  const set = e => {
    const { name, value } = e.target;
    if (name === 'supplier_id') {
      // When supplier changes, clear brand and lines if brand doesn't belong to this supplier
      const currentBrandOk = brandsForSupplier.some(b => String(b.id) === String(form.brand_id));
      setForm(f => ({
        ...f,
        supplier_id: value,
        brand_id: currentBrandOk ? f.brand_id : '',
      }));
      if (!currentBrandOk) setLines([]);
    } else if (name === 'brand_id') {
      // When brand changes, auto-fill supplier and clear lines
      const brand = brands.find(b => String(b.id) === String(value));
      setForm(f => ({
        ...f,
        brand_id:    value,
        supplier_id: brand?.supplier_id || f.supplier_id,
      }));
      setLines([]);
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
    setErrors(er => ({ ...er, [name]: '' }));
  };

  // Auto-calculate totals from lines
  useEffect(() => {
    if (lines.length === 0) return;
    const total_qty   = lines.reduce((s,l) => s + (parseInt(l.quantity)||0), 0);
    const total_price = lines.reduce((s,l) => s + (parseFloat(l.unit_price)||0)*(parseInt(l.quantity)||0), 0);
    setForm(f => ({ ...f, total_qty, total_price: total_price.toFixed(2) }));
  }, [lines]);

  const handleItemChange = (idx, itemId) => {
    setLines(ls => ls.map((l,i) => i===idx
      ? { ...l, item_id: itemId, unit_price: '' }
      : l
    ));
  };
  const setLine = (idx, field, val) =>
    setLines(ls => ls.map((l,i) => i===idx ? { ...l, [field]: val } : l));
  const addLine = () => setLines(ls => [...ls, { ...EMPTY_LINE }]);
  const delLine = idx => setLines(ls => ls.filter((_,i) => i!==idx));

  // ── Unit Cost Calculator handlers ───────────────────────
  const setPoC = e => setPoCalc(v => ({ ...v, [e.target.name]: e.target.value }));

  // Total Cost (PKR) = Quantity × Single Unit Cost (PKR) — auto-filled, but
  // stays editable: only overwritten while it still matches our own last
  // suggestion, so a manual edit sticks.
  useEffect(() => {
    const qty    = parseFloat(poCalc.qty) || 0;
    const single = parseFloat(poCalc.single_unit_cost_pkr) || 0;
    const auto   = qty * single;
    const autoStr = auto ? auto.toFixed(2) : '';
    setPoCalc(c => {
      if (c.pkr_cost && c.pkr_cost !== lastAutoPkrCost) return c; // user typed a custom value — leave it
      return { ...c, pkr_cost: autoStr };
    });
    setLastAutoPkrCost(autoStr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poCalc.qty, poCalc.single_unit_cost_pkr]);

  // Total Cost (BDT) = Total Cost (PKR) × Exchange Rate — auto-filled, but
  // stays editable the same way.
  useEffect(() => {
    const pkr  = parseFloat(poCalc.pkr_cost)      || 0;
    const rate = parseFloat(poCalc.exchange_rate) || 0;
    const auto = pkr / rate;
    const autoStr = auto ? auto.toFixed(2) : '';
    setPoCalc(c => {
      if (c.unit_cost && c.unit_cost !== lastAutoUnitCost) return c; // user typed a custom value — leave it
      return { ...c, unit_cost: autoStr };
    });
    setLastAutoUnitCost(autoStr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poCalc.pkr_cost, poCalc.exchange_rate]);

  // Delivery Charge (৳) = KG/Rate × Package Weight — auto-filled onto the real form field
  // (these are genuine PO fields now, saved to the DB, not calculator-only helpers)
  useEffect(() => {
    const kg = parseFloat(kgRate) || 0;
    const w  = parseFloat(form.weight_of_package) || 0;
    const val = kg * w;
    setForm(f => ({ ...f, delivery_charge: val ? val.toFixed(2) : '0' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kgRate, form.weight_of_package]);

  const handlePoCalc = () => {
    const qty  = parseFloat(poCalc.qty)           || 0;
    const unit = parseFloat(poCalc.unit_cost)     || 0;
    const del  = parseFloat(form.delivery_charge) || 0;
    const oth  = parseFloat(form.other_cost)      || 0;
    if (qty <= 0) { alert('Please enter a valid quantity'); return; }
    setPoCalcResult((unit + del + oth) / qty);
    setCalcMargin(''); setCalcSellingPrice(null);
  };

  const handleApplyToAllLines = () => {
    if (poCalcResult === null || lines.length === 0) return;
    const priceStr = poCalcResult.toFixed(2);
    setLines(ls => ls.map(l => ({ ...l, unit_price: priceStr })));
  };

  // Step 2 — profit margin on top of Cost per Unit → Selling Price reference
  const applyCalcMargin = () => {
    if (poCalcResult === null) return;
    const margin = parseFloat(calcMargin) || 0;
    setCalcSellingPrice(poCalcResult * (1 + margin / 100));
  };

  const resetPoCalc = () => {
    setPoCalc(EMPTY_PO_CALC); setPoCalcResult(null); setKgRate('');
    setCalcMargin(''); setCalcSellingPrice(null);
    setLastAutoPkrCost(''); setLastAutoUnitCost('');
  };

  // Auto-generate PO Number once both supplier and brand are chosen (new PO only).
  // Only overwrites the field if it's empty or still equal to our own last suggestion,
  // so it never clobbers something the user typed in manually.
  useEffect(() => {
    if (modal !== 'add') return;
    if (!form.supplier_id || !form.brand_id) return;
    if (form.po_number && form.po_number !== lastAutoPo) return;

    let cancelled = false;
    (async () => {
      try {
        const res  = await poApi.nextNumber(form.supplier_id, form.brand_id);
        const next = res?.data?.data?.po_number;
        if (next && !cancelled) {
          setForm(f => ({ ...f, po_number: next }));
          setLastAutoPo(next);
        }
      } catch { /* non-blocking — user can type the PO number manually */ }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.supplier_id, form.brand_id, modal]);

  // ── Create Item (inline) ─────────────────────────────────
  const setNewItemField = e => setNewItem(v => ({ ...v, [e.target.name]: e.target.value }));

  // Auto-build "Item Name" from Brand + Color + Additional Name — only while
  // the field still matches our own last suggestion, so a manual edit sticks
  useEffect(() => {
    const brandName = brands.find(b => String(b.id) === String(form.brand_id))?.brand_name || '';
    const colorName  = colors.find(c => String(c.id) === String(newItem.color_variation_id))?.color_variation || '';
    if (!brandName || !colorName) return;
    const auto = [brandName, colorName, newItem.additional_name.trim()].filter(Boolean).join('_');
    setNewItem(v => {
      if (v.item_name && v.item_name !== lastAutoItemName) return v; // user typed something custom — leave it
      return { ...v, item_name: auto };
    });
    setLastAutoItemName(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.brand_id, newItem.color_variation_id, newItem.additional_name, brands, colors]);

  // Pre-fill "Cost per Item" from the Unit Cost Calculator's Cost per Unit —
  // only while it still matches our own last suggestion, so a manual edit sticks
  useEffect(() => {
    if (poCalcResult === null) return;
    const auto = poCalcResult.toFixed(2);
    setNewItem(v => {
      if (v.cost_per_item && v.cost_per_item !== lastAutoCost) return v;
      return { ...v, cost_per_item: auto };
    });
    setLastAutoCost(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poCalcResult]);

  // Pre-fill "Selling Price" from the calculator's Step 2 margin result —
  // only while it still matches our own last suggestion, so a manual edit sticks
  useEffect(() => {
    if (calcSellingPrice === null) return;
    const auto = calcSellingPrice.toFixed(2);
    setNewItem(v => {
      if (v.selling_price && v.selling_price !== lastAutoSellingPrice) return v;
      return { ...v, selling_price: auto };
    });
    setLastAutoSellingPrice(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcSellingPrice]);

  const resetNewItem = () => {
    setNewItem(EMPTY_NEW_ITEM); setNewItemErrors({});
    setLastAutoItemName(''); setLastAutoCost(''); setLastAutoSellingPrice('');
  };

  const handleCreateItem = async () => {
    const e = {};
    if (!form.brand_id) e.brand = 'Select a brand above first';
    if (!newItem.color_variation_id) e.color = 'Select a color / variation';
    if (!newItem.item_name.trim()) e.item_name = 'Item name is required';
    else {
      const nameLower = newItem.item_name.trim().toLowerCase();
      const dup = allItems.some(i => i.item_name?.trim().toLowerCase() === nameLower);
      if (dup) e.item_name = 'An item with this name already exists';
    }
    if (!newItem.selling_price || isNaN(newItem.selling_price) || Number(newItem.selling_price) < 0) e.selling_price = 'Valid selling price is required';
    setNewItemErrors(e);
    if (Object.keys(e).length) { toast.error('Please fill in all required fields'); return; }

    setCreatingItem(true);
    try {
      const fd = new FormData();
      fd.append('brand_id', form.brand_id);
      fd.append('color_variation_id', newItem.color_variation_id);
      fd.append('item_name', newItem.item_name.trim());
      fd.append('description', newItem.description || '');
      fd.append('price', newItem.selling_price);
      fd.append('date_created', getBDDate());

      const res = await itemsApi.create(fd);
      const newId = res?.data?.id;
      toast.success('Item created');
      await reloadItems(); // so it shows up in the "Items to Purchase" dropdown

      // Add it straight onto the PO as a line, seeded with the Cost per Item
      // value shown above — same Cost per Unit that "Apply to All Lines" uses,
      // so every line on this PO is priced consistently.
      if (newId) {
        setLines(ls => [...ls, { item_id: String(newId), unit_price: newItem.cost_per_item || '', quantity: 1 }]);
      }
      resetNewItem();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to create item');
    } finally {
      setCreatingItem(false);
    }
  };

  const openAdd = () => {
    setForm(EMPTY); setLines([]); setErrors({}); resetPoCalc(); resetNewItem(); setLastAutoPo(''); setModal('add');
  };

  const openEdit = async (row) => {
    setSaving(true);
    try {
      const res = await poApi.getOne(row.id);
      const po  = res.data.data;
      setForm({
        ...po,
        weight_of_package: po.weight_of_package ?? '',
        delivery_charge:   po.delivery_charge   ?? '0',
        other_cost:        po.other_cost        ?? '0',
      });
      setLines(po.details?.length > 0 ? po.details.map(d => ({
        item_id:    d.item_id,
        unit_price: d.unit_price,
        quantity:   d.quantity,
      })) : []);
      setErrors({});
      resetNewItem();

      // Restore the full Unit Cost Calculator from what was saved on this PO,
      // so editing shows everything back instead of blank fields
      const qty      = po.calc_qty          ?? '';
      const singlePkr = po.calc_single_unit_cost_pkr ?? '';
      const pkrCost  = po.calc_pkr_cost     ?? '';
      const exRate   = po.calc_exchange_rate ?? '';
      const unitCostBdt = (parseFloat(pkrCost) || 0) * (parseFloat(exRate) || 0);
      setPoCalc({
        qty: qty === '' ? '' : String(qty),
        single_unit_cost_pkr: singlePkr === '' ? '' : String(singlePkr),
        pkr_cost: pkrCost === '' ? '' : String(pkrCost),
        exchange_rate: exRate === '' ? '' : String(exRate),
        unit_cost: unitCostBdt ? unitCostBdt.toFixed(2) : '',
      });
      setCalcMargin(''); setCalcSellingPrice(null);
      // Mark the restored values as "our own last auto-suggestion" so the
      // sticky auto-calc effects resume cascading normally on the next edit
      // (otherwise the first change after opening wouldn't recompute)
      setLastAutoPkrCost(pkrCost === '' ? '' : String(pkrCost));
      setLastAutoUnitCost(unitCostBdt ? unitCostBdt.toFixed(2) : '');

      // Back-derive the KG/Rate helper from the saved weight+delivery charge, so
      // editing an existing PO shows a sensible starting rate instead of blank
      const w = parseFloat(po.weight_of_package) || 0;
      const d = parseFloat(po.delivery_charge) || 0;
      setKgRate(w > 0 ? (d / w).toFixed(2) : '');

      // Immediately show the Cost per Unit result too (no need to click Calculate again)
      const qtyNum = parseFloat(qty) || 0;
      const del    = parseFloat(po.delivery_charge) || 0;
      const oth    = parseFloat(po.other_cost) || 0;
      setPoCalcResult(qtyNum > 0 ? (unitCostBdt + del + oth) / qtyNum : null);

      setLastAutoPo('');
      setModal('edit');
    } catch { toast.error('Failed to load PO'); }
    finally { setSaving(false); }
  };

  const validate = () => {
    const e = {};
    if (!form.po_number?.trim()) e.po_number  = 'PO number is required';
    if (!form.supplier_id)       e.supplier_id = 'Select a supplier';
    if (!form.brand_id)          e.brand_id    = 'Select a brand';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = () => {
    if (!validate()) { toast.error('Please fill in all required fields'); return; }
    const payload = {
      ...form,
      details: lines.filter(l => l.item_id),
      calc_qty: poCalc.qty || null,
      calc_single_unit_cost_pkr: poCalc.single_unit_cost_pkr || null,
      calc_pkr_cost: poCalc.pkr_cost || null,
      calc_exchange_rate: poCalc.exchange_rate || null,
    };
    if (modal==='add') doSubmit(() => poApi.create(payload), 'PO created', reload, () => setModal(null));
    else               doSubmit(() => poApi.update(form.id, payload), 'PO updated', reload, () => setModal(null));
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      await downloadReport(poApi.exportExcel, 'purchase-orders-list.xlsx');
    } catch {
      toast.error('Export failed — please try again');
    } finally {
      setExporting(false);
    }
  };

  const filtered = data.filter(r =>
    !search ||
    r.po_number?.toLowerCase().includes(search.toLowerCase()) ||
    r.supplier_name?.toLowerCase().includes(search.toLowerCase()) ||
    r.brand_name?.toLowerCase().includes(search.toLowerCase())
  );

  const lineTotal = lines.reduce((s,l) => s + (parseFloat(l.unit_price)||0)*(parseInt(l.quantity)||0), 0);
  const lineQty   = lines.reduce((s,l) => s + (parseInt(l.quantity)||0), 0);

  return (
    <div>
      <PageHeader title="Purchase Orders" subtitle="Create and manage purchase orders"
        action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ New PO</button>} />

      <div className="card">
        <div className="card-header">
          <div className="search-wrap">
            <Icons.Search size={14} className="search-icon" />
            <input type="text" className="search-input" placeholder="Search by PO#, supplier or brand…"
              value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <button className="btn btn-secondary btn-sm" onClick={handleExport} disabled={exporting}>
            {exporting ? 'Exporting…' : 'Export Excel'}
          </button>
        </div>
        {loading ? <Spinner /> : (
          <div className="table-wrap">
            {filtered.length===0 ? <Empty msg="No purchase orders yet" /> : (
              <table className="responsive-table">
                <thead><tr>
                  <th>PO #</th><th>Supplier / Brand</th>
                  <th>Qty</th><th>Total</th><th>Arrival</th><th>Status</th><th>Actions</th>
                </tr></thead>
                <tbody>{filtered.map(r => (
                  <tr key={r.id}>
                    <td data-label="PO #">
                      <div className="td-primary font-mono">{r.po_number}</div>
                      <div className="td-muted">{r.po_date}</div>
                    </td>
                    <td data-label="Supplier / Brand">
                      <div className="td-primary">{r.supplier_name}</div>
                      <div className="td-muted">{r.brand_name}</div>
                    </td>
                    <td data-label="Qty" className="font-mono">{r.total_qty}</td>
                    <td data-label="Total" className="font-mono">৳{Number(r.total_price).toLocaleString()}</td>
                    <td data-label="Arrival" className="text-muted">{r.arrival_date||'—'}</td>
                    <td data-label="Status"><Badge status={r.status} /></td>
                    <td data-label="Actions"><div className="action-cell">
                      <EditBtn onClick={() => {
                        if (r.status === 'all_done') {
                          toast.error("This PO's goods have already been received (GRN completed) — it can no longer be edited");
                          return;
                        }
                        openEdit(r);
                      }} />
                      <CancelBtn onClick={() => submitForm(() => poApi.cancel(r.id),'PO set to pending',reload)} label="Set Pending" />
                      <PdfBtn href={poApi.pdf(r.id)} />
                    </div></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {saving && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 }}>
          <div style={{ background:'white', padding:'24px 32px', borderRadius:12, fontSize:'1rem' }}>Loading PO details…</div>
        </div>
      )}

      {modal && (
        <Modal title={modal==='add' ? 'New Purchase Order' : 'Edit Purchase Order'}
          onClose={() => setModal(null)} size="modal-lg"
          footer={<>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={poSaving}>{poSaving ? 'Saving…' : 'Save PO'}</button>
          </>}>

          <div className="form-row form-row-2">
            <Field label="PO Number" required>
              <input type="text" name="po_number" value={form.po_number} onChange={set}
                placeholder="e.g. PO-2024-001" autoFocus
                style={errors.po_number?{borderColor:'var(--c-danger)'}:{}} />
              {errors.po_number && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.po_number}</span>}
              {modal==='add' && (
                <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
                  Auto-generated once supplier + brand are selected — you can edit it if needed
                </span>
              )}
            </Field>
            <Field label="PO Date">
              <input type="date" name="po_date" value={form.po_date} onChange={set} />
            </Field>
          </div>

          {/* Supplier ↔ Brand cross-filtering */}
          <div className="form-row form-row-2">
            <Field label="Supplier" required>
              <select name="supplier_id" value={form.supplier_id} onChange={set}
                style={errors.supplier_id?{borderColor:'var(--c-danger)'}:{}}>
                <option value="">Select supplier…</option>
                {suppliers.filter(s=>s.active_yes_no).map(s =>
                  <option key={s.id} value={s.id}>{s.full_name}</option>)}
              </select>
              {errors.supplier_id && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.supplier_id}</span>}
              {form.supplier_id && (
                <span style={{fontSize:'.74rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
                  Showing {brandsForSupplier.length} brand{brandsForSupplier.length!==1?'s':''} for this supplier
                </span>
              )}
            </Field>
            <Field label="Brand" required>
              <select name="brand_id" value={form.brand_id} onChange={set}
                style={errors.brand_id?{borderColor:'var(--c-danger)'}:{}}>
                <option value="">Select brand…</option>
                {brandsForSupplier.map(b => <option key={b.id} value={b.id}>{b.brand_name}</option>)}
              </select>
              {errors.brand_id && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{errors.brand_id}</span>}
              {form.brand_id && supplierForBrand && !form.supplier_id && (
                <span style={{fontSize:'.74rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
                  Supplier: {suppliers.find(s=>String(s.id)===String(supplierForBrand.supplier_id))?.full_name}
                </span>
              )}
            </Field>
          </div>

          {form.brand_id && (
            <>
                  {/* ── Unit Cost Calculator ── */}
                  <div style={{ margin:'0 0 16px', padding:'16px 18px', background:'var(--c-accent-tint)', border:'1px solid var(--c-border)', borderLeft:'3px solid var(--c-accent)', borderRadius:'var(--r-md)' }}>
                    <div style={{ fontWeight:600, fontSize:'.88rem', color:'var(--c-text)', marginBottom:12 }}>
                      Unit Cost Calculator <span style={{ fontWeight:400, color:'var(--c-text-3)', fontSize:'.78rem' }}>— optional, fills Unit Cost for all lines</span>
                    </div>

                    <div style={{ fontSize:'.75rem', fontWeight:600, letterSpacing:'.08em', textTransform:'uppercase', color:'var(--c-text-3)', marginBottom:8 }}>
                      Step 1 — Enter Costs
                    </div>

                    <div className="form-row form-row-3" style={{ marginBottom:10 }}>
                      <Field label="Quantity (pcs)">
                        <input type="number" name="qty" value={poCalc.qty} onChange={setPoC} min="1" placeholder="e.g. 10" />
                      </Field>
                      <Field label="Single Unit Cost (PKR)">
                        <input type="number" name="single_unit_cost_pkr" value={poCalc.single_unit_cost_pkr} onChange={setPoC} min="0" step="0.01" placeholder="e.g. 50" />
                      </Field>
                      <Field label="Total Cost (PKR)">
                        <input type="number" name="pkr_cost" value={poCalc.pkr_cost} onChange={setPoC} min="0" step="0.01" placeholder="Auto: Qty × Single Unit Cost" />
                      </Field>
                    </div>

                    <div className="form-row form-row-3" style={{ marginBottom:10 }}>
                      <Field label="Exchange Rate">
                        <input type="number" name="exchange_rate" value={poCalc.exchange_rate} onChange={setPoC} min="0" step="0.01" placeholder="e.g. 3.5" />
                      </Field>
                      <Field label="Total Cost (BDT)">
                        <input type="number" name="unit_cost" value={poCalc.unit_cost} onChange={setPoC} min="0" step="0.01" placeholder="Auto: PKR / Exchange Rate" />
                      </Field>
                      <Field label="KG / Rate (৳)">
                        <input type="number" value={kgRate} onChange={e => setKgRate(e.target.value)}
                          min="0" step="0.01" placeholder="e.g. 250" />
                      </Field>
                    </div>

                    <div className="form-row form-row-3" style={{ marginBottom:10 }}>
                      <Field label="Package Weight (kg)">
                        <input type="number" name="weight_of_package" value={form.weight_of_package || ''}
                          onChange={set} min="0" step="0.01" placeholder="0.00" />
                      </Field>
                      <Field label="Shipping Charge (৳)">
                        <input type="number" value={form.delivery_charge} readOnly placeholder="Auto-calculated"
                          style={{ backgroundColor:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' }} />
                      </Field>
                      <Field label="Delivery Cost (৳)">
                        <input type="number" name="other_cost" value={form.other_cost} onChange={set}
                          min="0" step="0.01" placeholder="0.00" />
                      </Field>
                    </div>

                    <div style={{ display:'flex', justifyContent:'flex-end', marginBottom: poCalcResult !== null ? 12 : 0 }}>
                      <button type="button" className="btn btn-secondary" onClick={handlePoCalc}>
                        Calculate
                      </button>
                    </div>

                    {poCalcResult !== null && (
                      <>
                        <div style={{ padding:'10px 14px', background:'var(--c-surface)', border:'1px solid var(--c-border)', borderRadius:'var(--r-sm)', fontSize:'.88rem', marginBottom:12 }}>
                          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, flexWrap:'wrap' }}>
                            <div>
                              <span style={{ color:'var(--c-text-3)' }}>Cost per Unit: </span>
                              <strong className="font-mono" style={{ color:'var(--c-text)', fontSize:'1rem' }}>৳{poCalcResult.toFixed(2)}</strong>
                              <span style={{ color:'var(--c-text-3)', marginLeft:12, fontSize:'.78rem' }}>
                                = ({poCalc.unit_cost || 0} + {form.delivery_charge || 0} + {form.other_cost || 0}) ÷ {poCalc.qty}
                              </span>
                            </div>
                            <button type="button" className="btn btn-primary btn-sm" onClick={handleApplyToAllLines} disabled={lines.length===0}>
                              Apply → All Lines
                            </button>
                          </div>
                        </div>

                        <div style={{ fontSize:'.75rem', fontWeight:600, letterSpacing:'.08em', textTransform:'uppercase', color:'var(--c-text-3)', marginBottom:8 }}>
                          Step 2 — Add Profit Margin
                        </div>
                        <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'flex-end' }}>
                          {[10,20,30,40,50].map(pct => (
                            <button key={pct} type="button"
                              className={`btn btn-sm ${String(calcMargin)===String(pct) ? 'btn-primary' : 'btn-secondary'}`}
                              onClick={() => setCalcMargin(pct)}>
                              +{pct}%
                            </button>
                          ))}
                          <div style={{ display:'flex', gap:6, alignItems:'center', flex:'0 0 auto' }}>
                            <input type="number" value={calcMargin} onChange={e => setCalcMargin(e.target.value)}
                              placeholder="Custom %" min="0" step="0.01" style={{ width:100 }} />
                            <span style={{ fontSize:'.82rem', color:'var(--c-text-3)' }}>%</span>
                          </div>
                          <button type="button" className="btn btn-primary btn-sm" onClick={applyCalcMargin} disabled={!calcMargin}>
                            Apply → Selling Price
                          </button>
                        </div>

                        {calcSellingPrice !== null && (
                          <div style={{ marginTop:10, fontSize:'.84rem', color:'var(--c-text-2)' }}>
                            ৳{poCalcResult.toFixed(2)} × {(1 + parseFloat(calcMargin||0)/100).toFixed(2)} =
                            <strong style={{ color:'var(--c-accent)', marginLeft:4 }}>
                              Selling Price ৳{calcSellingPrice.toFixed(2)}
                            </strong>
                            <span style={{ color:'var(--c-text-3)', marginLeft:8, fontSize:'.76rem' }}>
                              — pre-fills "Selling Price" below when creating a new item
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
            </>
          )}

          {/* ── Create Item (inline) ── */}
          {form.brand_id && (
            <div style={{ margin:'0 0 16px', padding:'16px 18px', background:'var(--c-accent-tint)', border:'1px solid var(--c-border)', borderLeft:'3px solid var(--c-accent)', borderRadius:'var(--r-md)' }}>
              <div style={{ fontWeight:600, fontSize:'.88rem', color:'var(--c-text)', marginBottom:12 }}>
                Create New Item <span style={{ fontWeight:400, color:'var(--c-text-3)', fontSize:'.78rem' }}>— optional, adds it to this brand and to the PO below</span>
              </div>

              <div className="form-row form-row-2" style={{ marginBottom:10 }}>
                <Field label="Color / Variation" required>
                  <select name="color_variation_id" value={newItem.color_variation_id} onChange={setNewItemField}
                    style={newItemErrors.color ? {borderColor:'var(--c-danger)'} : {}}>
                    <option value="">Select color…</option>
                    {colors.filter(c=>c.active_yes_no).map(c => <option key={c.id} value={c.id}>{c.color_variation}</option>)}
                  </select>
                  {newItemErrors.color && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.color}</span>}
                </Field>
                <Field label="Additional Name (optional)">
                  <input type="text" name="additional_name" value={newItem.additional_name} onChange={setNewItemField}
                    placeholder="e.g. Slim Fit" />
                </Field>
              </div>

              <Field label="Item Name" required>
                <input type="text" name="item_name" value={newItem.item_name} onChange={setNewItemField}
                  placeholder="Auto-built from Brand + Color + Additional Name — you can edit it"
                  style={newItemErrors.item_name ? {borderColor:'var(--c-danger)'} : {}} />
                {newItemErrors.item_name && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.item_name}</span>}
              </Field>

              <div className="form-row form-row-2" style={{ margin:'10px 0' }}>
                <Field label="Cost per Item (৳)">
                  <input type="number" name="cost_per_item" value={newItem.cost_per_item} onChange={setNewItemField}
                    min="0" step="0.01" placeholder="From calculator above, or type manually" />
                  <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
                    Same Cost per Unit as the PO line above (item + delivery + other)
                  </span>
                </Field>
              
                <Field label="Selling Price (৳)" required>
                  <input type="number" name="selling_price" value={newItem.selling_price} onChange={setNewItemField}
                    min="0" step="0.01" placeholder="Use Step 2 above, or type manually"
                    style={newItemErrors.selling_price ? {borderColor:'var(--c-danger)'} : {}} />
                  {newItemErrors.selling_price && <span style={{fontSize:'.75rem',color:'var(--c-danger)'}}>{newItemErrors.selling_price}</span>}
                </Field>
              </div>

              <Field label="Description">
                <textarea name="description" value={newItem.description} onChange={setNewItemField} rows={2}
                  placeholder="Optional product description…" />
              </Field>

              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:10 }}>
                <button type="button" className="btn btn-primary btn-sm" onClick={handleCreateItem} disabled={creatingItem}>
                  {creatingItem ? 'Saving…' : 'Save Item'}
                </button>
              </div>
            </div>
          )}

          {/* ── Item lines ── */}
          {form.brand_id ? (
            <>
              <div className="section-label" style={{marginTop:8}}>Items to Purchase</div>
              {filteredItems.length === 0 ? (
                <div style={{padding:'12px 14px',background:'var(--c-warning-lt)',border:'1px solid rgba(176,125,26,.2)',borderRadius:'var(--r-sm)',fontSize:'.84rem',color:'var(--c-warning)',marginBottom:12}}>
                  No active items found for this brand yet. Use "Create New Item" above to add one.
                </div>
              ) : (
                <>
                  <div style={{overflowX:'auto',marginBottom:8}}>
                    <table className="detail-table">
                      <thead><tr>
                        <th style={{minWidth:220}}>Item</th>
                        <th style={{minWidth:140}}>
                          Unit Cost (৳)
                          <span title="Unit cost = full landed cost per piece, including delivery and other charges (allocated evenly across quantity). Decided here, on the PO — GRN uses this total as-is."
                            style={{marginLeft:5,cursor:'help',color:'var(--c-text-3)',fontSize:'.75rem',
                              background:'var(--c-bg)',border:'1px solid var(--c-border)',
                              borderRadius:'50%',width:16,height:16,display:'inline-flex',
                              alignItems:'center',justifyContent:'center'}}>
                            ?
                          </span>
                        </th>
                        <th style={{minWidth:80}}>Qty</th>
                        <th style={{minWidth:110}}>Total Cost (৳)</th>
                        <th style={{width:36}}></th>
                      </tr></thead>
                      <tbody>
                        {lines.map((line,idx) => (
                          <tr key={idx}>
                            <td>
                              <select value={line.item_id} onChange={e => handleItemChange(idx, e.target.value)}>
                                <option value="">Select item…</option>
                                {filteredItems.map(i =>
                                  <option key={i.id} value={i.id}>{i.item_name}</option>)}
                              </select>
                            </td>
                            <td>
                              <input type="number" value={line.unit_price} min="0" step="0.01"
                                placeholder="0.00"
                                onChange={e => setLine(idx,'unit_price',e.target.value)} />
                            </td>
                            <td>
                              <input type="number" value={line.quantity} min="1"
                                onChange={e => setLine(idx,'quantity',e.target.value)} />
                            </td>
                            <td className="fw-500 font-mono">
                              ৳{((parseFloat(line.unit_price)||0)*(parseInt(line.quantity)||0)).toLocaleString()}
                            </td>
                            <td>
                              <button className="del-btn" onClick={() => delLine(idx)} title="Remove">
                                <Icons.Cancel size={13}/>
                              </button>
                            </td>
                          </tr>
                        ))}
                        {lines.length===0 && (
                          <tr>
                            <td colSpan={5} style={{textAlign:'center',color:'var(--c-text-3)',padding:'16px',fontSize:'.84rem'}}>
                              No items added yet — click "+ Add Item" below.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
                    <button className="btn btn-ghost btn-sm" onClick={addLine}>
                      <Icons.Plus size={13}/> Add Item
                    </button>
                    {lines.length > 0 && (
                      <span style={{fontSize:'.88rem',color:'var(--c-text-2)'}}>
                        Total Cost: <strong className="font-mono">৳{lineTotal.toLocaleString()}</strong>
                        &nbsp;|&nbsp; Qty: <strong>{lineQty}</strong>
                      </span>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{padding:'10px 14px',background:'var(--c-bg)',borderRadius:'var(--r-sm)',fontSize:'.84rem',color:'var(--c-text-3)',marginBottom:12,border:'1px dashed var(--c-border)'}}>
              Select a supplier and brand above to add items to this purchase order.
            </div>
          )}

          {/* Summary totals */}
          <div className="form-row form-row-3">
            <Field label="Total Qty">
              <input type="number" name="total_qty" value={form.total_qty} onChange={set} min="0" placeholder="0"
                readOnly={lines.length > 0}
                style={lines.length > 0 ? { background:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' } : {}} />
            </Field>
            <Field label="Total Cost (৳)">
              <input type="number" name="total_price" value={form.total_price} onChange={set} min="0" step="0.01" placeholder="0.00"
                readOnly={lines.length > 0}
                style={lines.length > 0 ? { background:'var(--c-bg)', color:'var(--c-text-2)', cursor:'not-allowed' } : {}} />
              {lines.length > 0 && (
                <span style={{fontSize:'.72rem',color:'var(--c-text-3)',marginTop:3,display:'block'}}>
                  Auto-calculated from item lines above — already includes Delivery &amp; Other Cost.
                </span>
              )}
            </Field>
            <Field label="Arrival Date">
              <input type="date" name="arrival_date" value={form.arrival_date||''} onChange={set} />
            </Field>
          </div>

          <Field label="Purchase Note">
            <textarea name="what_to_purchase" value={form.what_to_purchase||''} onChange={set} rows={2}
              placeholder="Additional notes…" />
          </Field>
          <Field label="Status">
            <select name="status" value={form.status} onChange={set}>
              {statuses.map(s => <option key={s.id} value={s.status}>{s.status}</option>)}
            </select>
          </Field>
        </Modal>
      )}
    </div>
  );
}